export default __webpack_public_path__ + "static/media/dashboard-light.4f87f330.svg";